<template>
  <div class="page">
    <YorkbbsHeader :width="'1170px'"></YorkbbsHeader>

    <YorkbbsSkeleton class="kjwt-skeleton row" :count="1" :loading="advLoading">
      <div slot="template" class="kjwt-skeleton__item">
        <el-skeleton-item variant="image"></el-skeleton-item>
      </div>
    </YorkbbsSkeleton>

    <!-- 广告 -->
    <div class="kjwt-row" v-show="!advLoading">
      <YorkbbsAdvItem v-for="i in 20" :key="i" :data="adv[`top_${i}`]"></YorkbbsAdvItem>
    </div>

    <section class="page-wrapper">
      <YorkbbsSearch :placeholder="'请输入品牌/车系，如 奥迪A8​'"></YorkbbsSearch>
      <YorkbbsTopic></YorkbbsTopic>
      <!-- 头条 -->
      <div class="toutiao">
        <div class="toutiao-left">
          <YorkbbsSkeleton class="recomm-skeleton"  :loading="recommand.loading" v-if="recommand.loading">
            <div slot="template" class="recomm-skeleton__item">
              <el-skeleton-item variant="image"></el-skeleton-item>
              <el-skeleton-item variant="p"></el-skeleton-item>
            </div>
          </YorkbbsSkeleton>
          <template v-if="!recommand.loading">
          <swiper class="toutiao-swiper" :options="recommand.options" >
            <swiper-slide v-for="(item, i) in recommand.list" :key="i">
              <YorkbbsQualityItem :data="item"></YorkbbsQualityItem>
            </swiper-slide>
            <div
              class="toutiao-swiper__pagination swiper-pagination"
              slot="pagination"
              v-show="recommand.list.length > 1"
            ></div>
          </swiper>
          </template>
        </div>
        <div class="toutiao-center">
          <YorkbbsSkeleton class="toutiao-skeleton" :rows="8" :loading="news.loading"></YorkbbsSkeleton>

          <ul class="toutiao-list" v-show="!news.loading">
            <li class="toutiao-item e" v-for="(post, i) in news.list" :key="`toutiao-big-${i}`">
              <a class="toutiao-item__link" target="_blank" :href="`/specials/subject/${post.id}` | hostBuild('news')" v-if="post.property.cmsType==6">{{post.title}}</a>
              <a class="toutiao-item__link" target="_blank" :href="`/detail/car/${post.id}` | hostBuild('news')" v-else>{{post.title}}</a>
            </li>
          </ul>
        </div>
        <div class="toutiao-right">
          <YorkbbsSkeleton class="kjwt-skeleton card" :loading="recommand.loading">
            <div slot="template" class="kjwt-skeleton__item">
              <el-skeleton-item variant="image"></el-skeleton-item>
            </div>
          </YorkbbsSkeleton>

          <!-- 广告 -->
          <div class="kjwt-column">
            <YorkbbsAdvItem v-for="i in 20" :key="i" :data="adv[`right_${i}`]"></YorkbbsAdvItem>
          </div>
        </div>
      </div>
      <!-- 汽车销售 -->
      <dl class="saler">
        <dt class="saler-header">
          <div class="saler-header__left">
            <span class="saler-header__name">汽车华人销售</span>
          </div>
        </dt>
        <dd>
          <YorkbbsSkeleton class="saler-skeleton" :count="5" :loading="saler.loading" v-if="saler.loading">
            <div slot="template" class="saler-skeleton__item">
              <el-skeleton-item variant="image"></el-skeleton-item>
              <el-skeleton-item class="p1" variant="p"></el-skeleton-item>
              <el-skeleton-item class="p2" variant="p"></el-skeleton-item>
            </div>
          </YorkbbsSkeleton>
          <div @click="swiperMouseMove" @mouseenter="swiperMouseMove" @mouseleave="swiperMouseLeave" v-show="!saler.loading">
          
            <swiper class="saler-swiper" :options="saler.options" ref="swiper">
              <swiper-slide v-for="(swiper, i) in saler.list" :key="`swiper-${i}`">
                <YorkbbsSalerItem :data="swiper"></YorkbbsSalerItem>
              </swiper-slide>
              <div
                class="saler-swiper__pagination swiper-pagination"
                slot="pagination"
                v-show="saler.list.length > 1"
              ></div>
            </swiper>
          </div>
        </dd>
      </dl>

      <YorkbbsSkeleton class="kjwt-skeleton row" :count="2" :loading="advLoading">
        <div slot="template" class="kjwt-skeleton__item">
          <el-skeleton-item variant="image"></el-skeleton-item>
        </div>
      </YorkbbsSkeleton>

      <!-- 广告 -->
      <div class="kjwt-row" v-show="!advLoading">
        <YorkbbsAdvItem v-for="i in 20" :key="i" :data="adv[`middle_${i}`]"></YorkbbsAdvItem>
      </div>

      <YorkbbsInfiniteLoading
        ref="tabInfinite"
        :immediate="true"
        :list="car.list"
        :loading="car.loading"
        :completed="car.completed"
        :loadingText="'正在获取更多车源'"
        @scroll="onPageScroll"
        @infinite="getPosts"
      >
        <div class="tab-list__wrapper" ref="tab">
          <ul class="tab-list" :style="{ position: tabFixed ? 'fixed' : 'relative' }">
            <li class="tab-item" :class="{ active: tabIndex === 0 }" @click="onTabChange(0)">推荐</li>
            <li class="tab-item" :class="{ active: tabIndex === 1 }" @click="onTabChange(1)">最新</li>
            <li class="tab-item">
              <router-link to="/list/used">二手车</router-link>
            </li>
            <li class="tab-item">
              <router-link to="/list/lease">转Lease</router-link>
            </li>
          </ul>
        </div>

        <div class="car-list">
          <template v-for="(item, i) in car.list">
            
            <YorkbbsInfoflowItem :key="`infoflow-${i}`" :data="item" v-if="item.app === 'crm_ad'"></YorkbbsInfoflowItem>
            <YorkbbsUsedItem
              :key="`used-${i}`"
              v-else-if="item.property.topics[0].englishName == 'used'"
              :data="item"
              :topVisible="tabIndex === 0"
            ></YorkbbsUsedItem>
            <YorkbbsLeaseItem
              :key="`lease-${i}`"
              v-else-if="item.property.topics[0].englishName == 'lease'"
              :data="item"
              :topVisible="tabIndex === 0"
            ></YorkbbsLeaseItem>
          </template>
        </div>
      </YorkbbsInfiniteLoading>
    </section>

    <!-- 返回顶部 -->
    <YorkbbsBackup
      :publishVisible="true"
      :publishTitle="'卖车'"
      :publishURL="'/publish/used'"
      :homeVisible="true"
      :homeURL="'/center/information?type=4' | hostBuild('home')"
      :opinionVisible="true"
    ></YorkbbsBackup>
  </div>
</template>
<script>
import { bannerAdvConvert, getViewportSize, inflowAdvConvert } from '@/utils/utils';
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsSearch from './search.vue';
import YorkbbsTopic from './topic.vue';
import YorkbbsQualityItem from './item-quality.vue';
import YorkbbsSalerItem from './item-saler.vue';
import YorkbbsUsedItem from '../components/item-used.vue';
import YorkbbsLeaseItem from '../components/item-lease.vue';
import YorkbbsInfiniteLoading from '@/common/infinite-loading/infinite-loading.vue';
import YorkbbsBackup from '@/common/tools-backup.vue';
import YorkbbsAdvItem from '@/common/item-adv.vue';
import YorkbbsInfoflowItem from '../components/item-infoflow.vue';
import YorkbbsSkeleton from '@/common/skeleton.vue';

export default {
  name: 'Home',
  components: {
    YorkbbsHeader,
    YorkbbsSearch,
    YorkbbsTopic,
    YorkbbsQualityItem,
    YorkbbsSalerItem,
    YorkbbsUsedItem,
    YorkbbsLeaseItem,
    YorkbbsInfiniteLoading,
    YorkbbsBackup,
    YorkbbsAdvItem,
    YorkbbsInfoflowItem,
    YorkbbsSkeleton,
  },
  data() {
    return {
      // 推荐新闻
      news: {
        loading: false,
        list: [],
      },

      // 推荐房源数据
      recommand: {
        loading: true,
        list: [],
        options: {
          loop: true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          spaceBetween: 15,
          pagination: {
            el: '.toutiao-swiper__pagination',
            clickable: true,
          },
        },
      },
      // 推荐销售列表
      saler: {
        loading: false,
        list: [],
        options: {
          loop: false,
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 17.5,
          pagination: {
            el: '.saler-swiper__pagination',
            clickable: true,
          },
        },
      },
      // 选项卡索引
      tabIndex: 0,
      // 选项卡汽车列表
      car: {
        loading: false,
        completed: false,
        offset: 1,
        size: 12,
        list: [],
        itemTotal: 0,
      },
      // 选项卡吸顶状态
      tabFixed: false,

      // 广告
      adv: {},
      advLoading: false,
    };
  },
  created() {
    this.getNews();
    this.getRecommList();
    this.getSalerList();

    this.getAdvList();
  },
  methods: {
    swiperMouseMove(){
      console.log(this.$refs.swiper.$swiper)
      console.log('swiperMouseMove')
      this.$refs.swiper.$swiper.autoplay.pause();
    },
    swiperMouseLeave(){
      console.log('swiperMouseLeave')
      this.$refs.swiper.$swiper.autoplay.run();
    },
    /**
     * 获取汽车销售列表
     */
    async getSalerList() {
      this.saler.loading = true;
      const { data } = await this.$axios.post('/car/v1/get/car/agent/list', { offset: 1, size: 15 }).finally(() => {
        this.saler.loading = false;
      });
      this.saler.list = data.items;
    },
    /**
     * 获取精品车源
     */
    async getRecommList() {
      this.recommand.loading = true;
      const { data } = await this.$axios.post('/car/v1/get/mainpage/boutique/post').finally(() => {
        this.recommand.loading = false;
      });
      this.recommand.list = data.items;
    },
    /**
     * 页面发生滚动时
     */
    onPageScroll(scrollTop) {
      this.tabFixed = scrollTop >= this.$refs.tab.offsetTop;
    },
    /**
     * 选项卡发生切换时
     */
    onTabChange(index) {
      if (this.tabIndex !== index) {
        const { h: viewH } = getViewportSize();
        const wrapperH = this.$refs.tabInfinite.$el.clientHeight;
        this.$refs.tabInfinite.$el.style.minHeight = Math.min(viewH, wrapperH) + 'px';

        this.tabIndex = index;
        this.car.loading = false;
        this.car.completed = false;
        this.car.offset = 1;
        this.car.list = [];
        this.getPosts();
      }
    },
    /**
     * 获取车源列表
     */
    async getPosts() {
      if (this.car.loading || this.car.completed) return;

      let url,
        params = { offset: this.car.offset, size: this.car.size };

      if (this.tabIndex === 0) {
        url = '/car/v1/get/mainpage/hot/post';
        params = { ...params };
      } else if (this.tabIndex === 1) {
        url = '/car/v1/get/post/list';
        params = { ...params, sort: ['createdAt:DESC'] };
      }

      this.car.loading = true;
      const { data } = await this.$axios.post(url, params).finally(() => {
        this.car.loading = false;
      });

      if (data.offset >= data.pageTotal) {
        this.car.completed = true;
      } else {
        this.car.offset++;
      }

      // 处理信息流广告轮显
      data.items = inflowAdvConvert(data.items, 'car', '10000');

      this.car.list.push(...data.items);
    },
    /**
     * 获取新闻
     */
    async getNews() {
      this.news.loading = true;
      const { data } = await this.$axios
        .post('/cms/v2/get/post/list', {
          topicId: ['b9196cf5-c016-41a9-884a-2abe4100a5bc'],
          offset: 1,
          size: 8,
          sort: ['createdAt:DESC'],
        })
        .finally(() => {
          this.news.loading = false;
        });

      this.news.list = data.items;
    },
    /**
     * 获取广告
     */
    async getAdvList() {
      const zoomId = 135556871;

      this.advLoading = true;
      const { data } = await this.$axios.post('/crm/section/v1/get/list/open', { id: zoomId }).finally(() => {
        this.advLoading = false;
      });

      this.adv = bannerAdvConvert(data, 'car', zoomId);

      console.log(this.adv);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
}
.page-wrapper {
  width: 1170px;
  margin: auto;
}

.toutiao {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
}
.toutiao-left,
.toutiao-right {
  width: 300px;
}
.toutiao-center {
  flex: 1;
  overflow: hidden;
  padding: 0 30px;
}
.toutiao-ad + .toutiao-ad {
  margin-top: 20px;
}
.toutiao-swiper {
  margin-bottom: 0;
}
.toutiao-item {
  position: relative;
  padding-left: 15px;
  margin-bottom: 1px;
  font-size: 16px;
  line-height: 32px;
  &::before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #ccc;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  &:hover {
    color: var(--primary-color);
  }
}

.toutiao-swiper__pagination {
  bottom: 70px;
  ::v-deep {
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #b6b6b6;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      width: 26px;
      background-color: #ffffff;
    }
  }
}

.saler {
  min-height: 200px;
  margin-bottom: 10px;
  position: relative;
}
.saler-header {
  position: relative;
}
.saler-header__left {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
}
.saler-header__name {
  line-height: 30px;
  font-size: 22px;
}
.saler-swiper {
  padding-top: 50px;
}
.saler-swiper__pagination {
  top: 0;
  bottom: inherit;
  text-align: right;
  ::v-deep {
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background: #cccccc;
    }
    .swiper-pagination-bullet-active {
      width: 26px;
      background-color: var(--primary-color);
    }
  }
}

.ad-list {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 10px;
}

.tab-list__wrapper {
  margin-bottom: 10px;
}

.tab-list__wrapper,
.tab-list,
.tab-item {
  box-sizing: border-box;
  height: 70px;
}

.tab-list {
  display: flex;
  z-index: 5;
  top: 0;
  width: 1170px;
  background-color: #fff;
}
.tab-item {
  font-size: 22px;
  line-height: 60px;
  font-weight: 500;
  margin-right: 25px;
  cursor: pointer;
  user-select: none;
  &.active {
    color: var(--primary-color);
  }
}
.car-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
  .used-item,
  .lease-item,
  .infoflow-item {
    &:not(:nth-child(4n)) {
      margin-right: 23.333333333px;
    }
  }
}

.car-status {
  padding: 50px 0;
  text-align: center;
  font-size: 20px;
  line-height: 28px;
  color: var(--text-color-9);
}

::v-deep {
  .kjwt-column {
    .kjwt-item {
      margin-bottom: 10px;
    }
  }

  .kjwt-row {
    width: 1170px;
    display: flex;
    margin: 0 auto;
    .kjwt-item {
      margin: 10px 0;
    }
    .kjwt-item + .kjwt-item {
      margin-left: 10px;
    }
  }
}

.recomm-skeleton {
  .recomm-skeleton__item {
    width: 280px;
    height: 266px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  ::v-deep {
    .el-skeleton__image {
      height: 210px;
    }
    .el-skeleton__p {
      display: block;
      margin-top: 13px;
      width: 50%;
    }
  }
}

.toutiao-skeleton {
  ::v-deep {
    .el-skeleton {
      height: 263px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .el-skeleton__p {
      display: block;
    }
    .el-skeleton__paragraph {
      margin: 0;
      display: block;
    }
  }
}

.kjwt-skeleton {
  &.row {
    width: 1170px;
    //height: 110px;
    margin: 0 auto;
    ::v-deep {
      .el-skeleton {
        display: flex;
        justify-content: space-between;
      }
      .kjwt-skeleton__item {
        width: 100%;
        height: 90px;
        margin:10px 0;
      }
      .el-skeleton__image {
        width: 100%;
        height: 100%;
      }
    }
  }
  &.card {
    .el-skeleton__image {
      width: 300px;
      height: 250px;
    }
  }
}

.saler-skeleton {
  padding-top: 50px;
  ::v-deep {
    .el-skeleton {
      display: flex;
      justify-content: space-between;
    }
    .saler-skeleton__item {
      width: 220px;
    }

    .el-skeleton__image {
      height: 220px;
    }
    .el-skeleton__p {
      display: block;
    }
    .p1 {
      width: 80%;
      margin-top: 20px;
    }
    .p2 {
      width: 60%;
      margin-top: 20px;
    }
  }
}
</style>
